import { documentDetailSearchFields } from '../../common/forms/documents/fields'

export const DOCUMENT_VALUE_ENDPOINTS = {
    type: 'v1/file/values/documentType',
} as const

export const documentsDetailSearchFieldsConfig = {
    type: documentDetailSearchFields.DOCUMENT_TYPE,
}
